import { z } from "zod";

/**
 * 応募先選択のバリデーションスキーマ
 */
export const clientSelectSectionSchema = z
  .object({
    clientId: z.number().optional(),
    clientShopId: z.number().optional(),
    jobEntryId: z.number().optional(),
  })
  // jobEntryId が設定されている場合は clientId を必須にしない
  .refine((data) => data.clientId !== undefined || data.jobEntryId !== undefined, {
    message: "選択してください。",
    path: ["clientId"],
  });
